import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import 'webshop/js/menu';
import {
  ShoppingCartManager,
  ShoppingCartContents,
  NavShoppingCart,
  PaymentOptions,
} from 'webshop/js/shopping-cart-manager';
import { onCheckoutOption, sendEnhancedAnalytics } from 'webshop/js/analytics';



$(document).ready(function() {
  const validateCustomerForm = () => {
    if ($('#customer-info form')[0]) {
      if ($('#customer-info form')[0].checkValidity()) {
        $('#customer-info-submit').removeClass('disabled');
      } else {
        $('#customer-info-submit').addClass('disabled');
      }
    }
  };

  sendEnhancedAnalytics(1);

  const sendSecondStepAnalytics = (identificationType) => {
    const shippingName = $('input[name="shipping"]:checked').next().text();
    onCheckoutOption(1, `Valittu toimitustapa: ${shippingName}`);
    sendEnhancedAnalytics(2, identificationType);
  };

  const scrollToCheckoutTop = () => {
    $('html, body').animate({
       scrollTop: ($('#checkout').offset().top)
     }, 500);
  };

  $('#confirm').hide();

  $('#shopping-cart > .dim').hide();

  $('#customer-info > .dim').hide();
  if ($('#shopping-cart-login-register').length == 1) {
    $('#register-box').hide();
    $('#customer-info').hide();
    $('#customer-info > .dim').show();
    $('#confirm').hide();
  }

  $('#register').on('click', (e) => {
    $('#login-box').toggle();
    $('#register-box').toggle();
    scrollToCheckoutTop();
    if ($('#register').text() == 'Luo käyttäjätili') {
      $('#register').text('Kirjaudu sittenkin sisään');
    } else {
      $('#register').text('Luo käyttäjätili');
    }
  });

  $('[name="submit_register"]').on('click', (e) => {
    sendSecondStepAnalytics('Rekisteröidy');
  });

  $('#continue').on('click', (e) => {
    $('#shopping-cart-login-register').hide();
    $('#customer-info').show();
    $('#customer-info > .dim').hide();
    $('#shopping-cart > .dim').show();
    scrollToCheckoutTop();
    sendSecondStepAnalytics('Jatka kirjautumatta');
  });

  var selector = '#shopping-cart > .cart-shipping > .product-name > .shipping-options > div > label > input[name="shipping"]';
  $('#shopping-cart-container').on('change', selector, (e) => {
      if($(this).val() != '7') {  // 7 is the value of Posti
        $('#shopping-cart-booking-calendar').show();
      } else {
        $('#shopping-cart-booking-calendar').hide();
      }
  });

  validateCustomerForm();

  const continueToCheckout = (customerData) => {
    for (let d in customerData) {
      $('.customer-info #id_' + d).val(customerData[d]);
    }
    validateCustomerForm();
    $('#shopping-cart-login-register').hide();
    $('#customer-info').show();
    $('#customer-info > .dim').hide();
    $('#confirm').show();
    scrollToCheckoutTop();
  };

  $('#login-form').on('submit', (e) => {
    e.preventDefault();
    const formData = $('#login-form').serialize();
  	$.ajax({
  		url: '/ajax-login/',
  		data: formData,
  		method: "POST",
  		success: function (returned_data) {
  			if (returned_data.errors) {
          $('#login-form #errors').text(returned_data.errors.__all__)
  			} else {
          sendSecondStepAnalytics('Kirjaudu');
          continueToCheckout(returned_data);
          $('#confirm').hide();
  			}
  		}
  	});
  });

  $('#register-form').on('submit', (e) => {
    e.preventDefault();
    const formData = $('#register-form').serialize();
  	$.ajax({
  		url: '/ajax-login/',
  		data: formData,
  		method: "POST",
  		success: function (returned_data) {
  			if (returned_data.errors) {
          $('#register-form #errors').text(returned_data.errors)
  			} else {
          continueToCheckout(returned_data);
          $('#shopping-cart-login-register').hide();
          $('#confirm').hide();
  			}
  		}
  	});
  });

  $('#customer-info').on('submit', (e) => {
    e.preventDefault();
    if ($('#customer-info-submit').hasClass('disabled'))
      return;

    const formData = $('form.customer-info').serialize();
  	$.ajax({
  		url: '/ajax-customer/',
  		data: formData,
  		method: "POST",
  		success: function (returned_data) {
  		 if (returned_data.errors) {
          $('form.customer-info #errors').text(returned_data.errors)
  		 } else {
          $('#customer-info > .dim').show();
          $('#confirm > .dim').hide();
          $('#confirm').show();
          $('html, body').animate({
             scrollTop: ($('#confirm').offset().top)
          }, 500);

          if ($('#shopping-cart-login-register').length == 0) {
              sendSecondStepAnalytics('Rekisteröidy');
          }
          sendEnhancedAnalytics(3);
  		 }
  		}
  	});
  });

  $('#customer-info form').change((e) => {
    validateCustomerForm();
  });

  let paymentMethod = 'cash'
  $('#confirm button').click(function() {
    paymentMethod = $(this).val();
  })

  $('#confirm-form').on('submit', (e) => {
    e.preventDefault();

    let formData = $('#confirm-form').serialize(),
        cashSubmit = $('button[value="cash"]'),
        invoiceSubmit = $('button[value="invoice"]'),
        klarnaSubmit = $('button[value="klarna"]');
    if (paymentMethod)
      formData += `&payment_method=${paymentMethod}`;

    cashSubmit.attr("disabled", true);
    cashSubmit.html('<i class="fa fa-spinner fa-spin"></i>');

    if (invoiceSubmit.length) {
      invoiceSubmit.attr("disabled", true);
      invoiceSubmit.html('<i class="fa fa-spinner fa-spin"></i>');
    }

    if (klarnaSubmit.length) {
      klarnaSubmit.attr("disabled", true);
      klarnaSubmit.html('<i class="fa fa-spinner fa-spin"></i>');
    }

  	$.ajax({
  		url: '/ajax-confirm/',
  		data: formData,
  		method: "POST",
  		success: function (returned_data) {
        cashSubmit.html('Maksa');
        cashSubmit.attr("disabled", false);

        if (invoiceSubmit.length) {
          invoiceSubmit.html('Osta laskulla');
          invoiceSubmit.attr("disabled", false);
        }

        if (klarnaSubmit.length) {
          klarnaSubmit.html('Maksa Klarnalla');
          klarnaSubmit.attr("disabled", false);
        }

  			if (returned_data.errors != undefined) {
          $('#confirm-errors').text(returned_data.errors);

  			} else if (returned_data.redirect) {
          window.location.href = returned_data.redirect;
        } else {
          $('#confirm > .dim').show();
          $('#confirm').hide();
          if (returned_data.bank_data) {
            Klarna.Payments.init({
              client_token: returned_data.bank_data.client_token
            });

            Klarna.Payments.load(
              {
                container: '#klarna-payments-container'
              },
              {},
              function (res) {
                console.debug(res);
              }
            )

            const KlarnaButtons = () => {
              const btns = returned_data.bank_data.payment_method_categories.map(c => (
                <div>
                  <img src={c.asset_urls.descriptive} />
                  <span>{c.name}</span>
                </div>
              ))

              const klarnaAuth = () => {
                $('#klarna-auth').prop("disabled", true);
                const authResp = Klarna.Payments.authorize(
                  {},
                  returned_data.order,
                  function(res) {
                    if (res.approved) {
                      $.ajax({
                        url: `/create-klarna-order/${returned_data.order_id}`,
                        data: {auth_token: res.authorization_token},
                        method: 'POST',
                        success: function (resp) {
                          if (resp.redirect_url) {
                            window.location.href = resp.redirect_url
                          }
                        }
                      });
                    } else {
                      // Authorization failed
                      window.location.href = '/klarna-failed'
                    }
                  }
                );
              };

              return (
                <div className="payment-option">
                  <h2 className="title">Valitse maksutapa</h2>
                  <div className="btn-container">
                    <div className="klarna-btn">
                      <h3>Klarna</h3>
                      {btns}
                      <button id="klarna-auth" className="btn" onClick={() => klarnaAuth()}>Valitse</button>
                    </div>
                  </div>
                </div>
              );
            }

            ReactDOM.render(<KlarnaButtons />, document.getElementById('payment'))

            $('html, body').animate({
              scrollTop: ($('#payment').offset().top)
            }, 500);

          } else {
            ReactDOM.render(
              <PaymentOptions banks={returned_data.banks}/>,
              document.getElementById('payment')
            );
            $('html, body').animate({
              scrollTop: ($('#payment').offset().top)
            }, 500);
          }
          sendEnhancedAnalytics(4);
        }
  	  }
  	});
  });
});

ShoppingCartManager.setData(window.initial_cart_data);
ReactDOM.render(React.createElement(ShoppingCartContents),
                document.getElementById('shopping-cart-container'));
ReactDOM.render(React.createElement(NavShoppingCart),
                document.getElementById('nav-cart'));



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/shopping-cart-view.js
 **/